import { Metric } from '@strength/domain';
import { I18nTranslator } from '@strength/i18n';
import { DateTime } from 'luxon';
import { ActualWorkout, WorkoutSummaryActualsMutationFns } from '../types';
import { ActualSlot } from './ActualSlot';
import { getSlotsForMonth } from './common';

export const getActualSlotsForMetricValue = (
  metricKeyword: string,
  actualsWorkouts: ActualWorkout[],
  mutationFns: WorkoutSummaryActualsMutationFns,
  month: number,
  year: number,
  x: number,
  y: number,
  getMetric: (metricId: string) => Metric,
  t: I18nTranslator,
  readOnly?: boolean,
) => {
  const getWorkoutForDay = (date: string) => {
    return actualsWorkouts.find((w) => w.workout?.assignedDate === date);
  };

  return getSlotsForMonth(
    x,
    y,
    month,
    year,
    (x, y, day) => {
      const curDay = DateTime.fromObject({ month, day, year }).toFormat(
        'yyyy-MM-dd',
      );
      const workout = getWorkoutForDay(curDay);
      return ActualSlot({
        x,
        y,
        workout,
        metricKeyword,
        mutationFns,
        getMetric,
        t,
        readOnly,
      });
    },
    true,
  );
};
